import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PlanModal from "@/components/PlanModal";

// Global listener: when a gated action returns 402 (trial ended or seat limit),
// open the Plan modal pre-selecting the plan that fits the family.
export default function UpgradePrompt() {
  const { user } = useAuth();
  const [state, setState] = useState(null); // { reason, recommended }

  useEffect(() => {
    const handler = async (e) => {
      if (!user || (user.subscription?.status === "active")) return;
      const message = e.detail?.message || "Upgrade to continue.";
      // Seat-limit messages mention Family; otherwise pick by child count.
      let recommended = /family/i.test(message) ? "family" : "monthly";
      if (recommended === "monthly") {
        try {
          const { data } = await api.get("/account/access");
          if ((data.children_count || 0) >= 2) recommended = "family";
        } catch { /* keep monthly */ }
      }
      setState({ reason: message, recommended });
    };
    window.addEventListener("ns:upgrade", handler);
    return () => window.removeEventListener("ns:upgrade", handler);
  }, [user]);

  if (!state || !user) return null;
  return (
    <PlanModal
      userId={user.id}
      currentPlan={user.subscription?.plan}
      subscribed={user.subscription?.status === "active"}
      reason={state.reason}
      recommended={state.recommended}
      onClose={() => setState(null)}
    />
  );
}
